import { render, staticRenderFns } from "./Kewajaran.vue?vue&type=template&id=50fdd95f&scoped=true"
import script from "./Kewajaran.vue?vue&type=script&lang=js"
export * from "./Kewajaran.vue?vue&type=script&lang=js"
import style0 from "./Kewajaran.vue?vue&type=style&index=0&id=50fdd95f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fdd95f",
  null
  
)

export default component.exports